import { Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { PopupManager } from '../../../popup/popup-manager.service';
import { StadiumBetsVisibilityService } from '../../services/stadium-bets-visibility.service';

@Component({
    selector: 'ms-stadium-my-bets',
    templateUrl: './stadium-my-bets.html',
    standalone: false,
})
export class StadiumMyBetsComponent {
    @Input() listType?: BetslipListType;

    constructor(
        private popupManager: PopupManager,
        public sitecore: Sitecore,
        private stadiumMyBetsService: StadiumBetsVisibilityService,
    ) {}

    openArchivedBetsPopup(): void {
        this.popupManager.open('archived-bets');
    }

    openTransactionBetsPopup(): void {
        this.popupManager.open('transaction-bets');
    }

    get showArchivedBets(): boolean {
        return this.stadiumMyBetsService.showArchivedBets(this.listType);
    }

    get showTransactionBets(): boolean {
        return this.stadiumMyBetsService.showTransactionBets(this.listType);
    }
}
